import React from "react";
import { useMediaQuery } from "@mui/material";

interface TabProps {
    tabs: string[];
    activeTab: string;
    onTabChange: (tab: string) => void;
    className?: string;
    mainTabStyle?: "default" | "alt"; // Prop to toggle between main tab styles
}

const Tab: React.FC<TabProps> = ({
                                     tabs,
                                     activeTab,
                                     onTabChange,
                                     className,
                                     mainTabStyle = "default",
                                 }) => {
    const isMobile = useMediaQuery("(max-width:1100px)"); // Adjusted media query for better transition
    return (
        <div
            className={`tab-container ${mainTabStyle === "alt" ? "justify-start gap-2 px-4" : "justify-start gap-4 border-b"} ${className} ${isMobile ? "" : "ml-72"}`}
        >
            {tabs.map((tab) => (
                <a
                    key={tab}
                    onClick={() => onTabChange(tab)}
                    className={`tab-button ${
                        mainTabStyle === "default"
                            ? activeTab === tab
                                ? "tab-button-default-active"
                                : "tab-button-default-inactive"
                            : activeTab === tab
                                ? "tab-button-alt-active"
                                : "tab-button-alt-inactive"
                    }`}
                >
                    {tab}
                </a>
            ))}
        </div>
    );
};

export default Tab;